import { render, staticRenderFns } from "./productionList.vue?vue&type=template&id=4116df78&"
import script from "./productionList.vue?vue&type=script&lang=js&"
export * from "./productionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports